<template>
  <div class="template-connected">
    <div id="container">
      <b-modal
        v-model="showMails"
        title="Détails des mails envoyés"
        hide-footer
        size="md"
        header-bg-variant="primary"
        header-text-variant="white"
      >
        <history-mail :id="showMailsId"></history-mail>
      </b-modal>
      <b-modal
        v-model="showRenew"
        title="Renouvellement de la demande"
        hide-footer
        size="xl"
        header-bg-variant="primary"
        header-text-variant="white"
      >
        <b-form @submit.prevent="handleSubmit(renew())">
          <div class="form-group">
            <div class="block-flat outlined">
              <h3 class="header readonly mb-3 no-padding">La demande</h3>
              <b-row>
                <b-col
                  xl="3"
                  lg="6"
                  md="6"
                  sm="12"
                  cols="12"
                  class="no-padding"
                >
                  <label class="control-label"
                    >Date prévue de début d'application
                    <span class="red">*</span> :</label
                  >
                </b-col>
                <b-col xl="9" lg="6" md="6" sm="12" cols="12">
                  <ValidationProvider
                    mode="lazy"
                    v-slot="{ errors }"
                    rules="required"
                    name="date de début"
                  >
                    <b-form-datepicker
                      hide-header
                      :start-weekday="1"
                      v-model="copyRequest.dateStart"
                      placeholder="Date prévue de début d'application"
                      @input="calcNumberDays($event)"
                      today-button
                      :state="errors[0] ? false : null"
                      today-button-variant="primary"
                      label-help=""
                      label-today-button="Aujourd'hui"
                    ></b-form-datepicker>
                    <div class="error">{{ errors[0] }}</div>
                  </ValidationProvider>
                </b-col>
                <b-col
                  xl="3"
                  lg="6"
                  md="6"
                  sm="12"
                  cols="12"
                  class="no-padding"
                >
                  <label class="control-label"
                    >Date prévue de fin d'application
                    <span class="red">*</span> :
                  </label>
                </b-col>
                <b-col xl="9" lg="6" md="6" sm="12" cols="12">
                  <ValidationProvider
                    mode="lazy"
                    v-slot="{ errors }"
                    rules="required"
                    name="date de fin"
                  >
                    <b-form-datepicker
                      hide-header
                      :state="errors[0] ? false : null"
                      :start-weekday="1"
                      v-model="copyRequest.dateEnd"
                      @input="calcNumberDays($event)"
                      placeholder="Date prévue de fin d'application"
                      today-button
                      today-button-variant="primary"
                      label-help=""
                      label-today-button="Aujourd'hui"
                    ></b-form-datepicker>
                    <div class="error">{{ errors[0] }}</div>
                  </ValidationProvider>
                  <!--  -->
                </b-col>
                <b-col
                  xl="3"
                  lg="6"
                  md="6"
                  sm="12"
                  cols="12"
                  class="no-padding"
                >
                  <label class="control-label">Nombre de jours : </label>
                </b-col>
                <b-col xl="9" lg="6" md="6" sm="12" cols="12">
                  <b-form-input
                    :disabled="true"
                    type="number"
                    v-model="copyRequest.numberDays"
                  />
                </b-col>
              </b-row>
            </div>
            <div v-if="copyRequest.cerfa14024" class="block-flat outlined">
              <h3 class="header readonly mb-3 no-padding">Le Cerfa</h3>
              <b-row>
                <b-col
                  xl="3"
                  lg="6"
                  md="6"
                  sm="12"
                  cols="12"
                  class="no-padding"
                >
                  <label class="control-label"
                    >Durée de la réglementation
                    <span>(en jours calendaires)</span>
                    <span class="red">*</span> :</label
                  >
                </b-col>
                <b-col xl="2" lg="6" md="6" sm="12" cols="12">
                  <ValidationProvider
                    mode="lazy"
                    v-slot="{ errors }"
                    rules="required"
                    name="durée de la réglementation "
                  >
                    <b-form-input
                      :state="errors[0] ? false : null"
                      v-model="copyCerfa14024.durationRegulation"
                      type="number"
                    />
                    <div class="error">{{ errors[0] }}</div>
                  </ValidationProvider>
                </b-col>
                <b-col
                  xl="3"
                  lg="6"
                  md="6"
                  sm="12"
                  cols="12"
                  class="no-padding"
                >
                  <label class="control-label"
                    >Date de début de réglementation
                    <span class="red">*</span> :</label
                  >
                </b-col>
                <b-col xl="4" lg="6" md="6" sm="12" cols="12">
                  <ValidationProvider
                    mode="lazy"
                    v-slot="{ errors }"
                    rules="required"
                    name="date de début de réglementation"
                  >
                    <b-form-datepicker
                      :state="errors[0] ? false : null"
                      hide-header
                      placeholder="Date"
                      today-button
                      :start-weekday="1"
                      today-button-variant="primary"
                      label-help=""
                      label-today-button="Aujourd'hui"
                      v-model="copyCerfa14024.dateRegulation"
                    ></b-form-datepicker>
                    <div class="error">{{ errors[0] }}</div>
                  </ValidationProvider>
                </b-col>
              </b-row>
            </div>
          </div>
          <div class="text-center">
            <b-button variant="success" type="submit"> Valider </b-button>
          </div>
        </b-form>
      </b-modal>
      <!-- <div id="title">
        <h1>Liste des demandes</h1>
      </div> -->
      <div
        :class="
          mapStatus == true
            ? 'block-flat block-flat-map'
            : 'block-flat block-flat-map small'
        "
      >
        <div class="header">
          <b-row>
            <b-col lg="8" md="8" sm="12" cols="12" class="no-padding">
              <h3>Liste des demandes</h3>
            </b-col>
            <b-col
              lg="4"
              md="4"
              sm="12"
              cols="12"
              class="no-padding text-right btn-map"
            >
              <b-button
                variant="white"
                class="btn-auto"
                @click="mapStatus = true"
                v-if="mapStatus === false"
              >
                <font-awesome-icon icon="map-marked-alt"></font-awesome-icon>
                Afficher carte
              </b-button>
              <b-button
                variant="dark"
                class="btn-auto"
                @click="mapStatus = false"
                v-else
              >
                <font-awesome-icon icon="map-marked-alt"></font-awesome-icon>
                Masquer carte
              </b-button>
            </b-col>
          </b-row>
        </div>
        <div class="block-content">
          <div id="container-map">
            <maps
              :draw="false"
              :defaultLayers="['TRANSPORTNETWORKS.ROADS']"
              :vectorLayers="vectorLayers"
              width="calc(100%)"
            ></maps>
          </div>
        </div>
      </div>
      <div id="content" style="min-width: 1570px !important;">
        <div class="block-flat">
          <!-- <b-row class="mb-4"> -->
            <!-- <b-col cols="12" sm="12" md="12" lg="12" xl="12" class="no-padding"> -->
              <!-- <div
                :class="
                  userConnected.roles.includes('ROLE_USER') ||
                  userConnected.roles.includes('ROLE_ADMIN')
                    ? 'd-inline-block icon-container'
                    : 'd-inline-block'
                "
                id="tooltip-legend"
              >
                <font-awesome-icon
                  size="2x"
                  :class="
                    userConnected.roles.includes('ROLE_USER') ||
                    userConnected.roles.includes('ROLE_ADMIN')
                      ? 'text-sudthd pointer icon-info'
                      : 'text-sudthd pointer'
                  "
                  icon="info-circle"
                ></font-awesome-icon>
                <b-tooltip
                  custom-class="tooltip-legend"
                  target="tooltip-legend"
                  triggers="click"
                >
                  <ul class="list-legend">
                    <li v-for="item in states" :key="item.name">
                      <p>
                        <span :class="'status-table statut-' + item.id"></span>
                        {{ item.name }}
                      </p>
                    </li>
                  </ul>
                </b-tooltip>
              </div>

              <button
                v-if="
                  userConnected.roles.includes('ROLE_USER') ||
                  userConnected.roles.includes('ROLE_SOUSTRAITANT') ||
                  userConnected.roles.includes('ROLE_ADMIN')
                "
                @click="goToNewDossier()"
                type="button"
                class="ml-2 d-inline btn btn-primary btn-block btn-auto"
              >
                <font-awesome-icon icon="plus"></font-awesome-icon>
                Nouvelle demande
              </button> -->
            <!-- </b-col> -->
          <!-- </b-row> -->

          <!-- Primevue -->
          <!-- responsiveLayout="scroll" -->
          <DataTable 
          :value="dossiers" 
          class="p-datatable-sm"
          :lazy="true"
          :totalRecords="paginationSelected.totalCount"
          :paginator="true" 
          @page="runSearch($event)"
          @sort="runSearch($event)" 
          @filter="runSearch($event)"
          :resizableColumns="true"
          columnResizeMode="fit" 
          sortField="id" 
          :sortOrder="-1"
          showGridlines 
          :rows="10" 
          dataKey="id"
          :filters.sync="filters"
          filterDisplay="menu"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown" 
          :rowsPerPageOptions="[10,25,50,100,250]"
          currentPageReportTemplate="Affichage des lignes {first} à {last} sur {totalRecords} au total"
          :globalFilterFields="[
            'cerfa1402301',
            'state_name',
            'ticketOfficePerimeter',
            'managerPerimeter',
            'operatorPerimeter',
            'sousTraitantPerimeter',
            'addressNum',
            'addressPostalCode',
            'addressCity',
            'zoneAMII',
            'depositDate',
            'dateStart'
          ]"
          stateStorage="local" 
          stateKey="dt-state-demo-session"
          >
            <template #header>
              <div style="width: 100%; display: flex !important; justify-content: space-between !important; align-items: end !important;">
                <!-- Recherche, Télécharger & Nouvelle Demande -->
                <div style="display: flex; align-items: center !important;">
                  <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <InputText 
                      v-model="filters['global'].value" 
                      placeholder="Recherche" 
                      @keypress.enter="runSearch({first : 0,
                      rows : 10,
                      sortField : 'id',
                      sortOrder : -1,
                      filters : filters})"
                      v-b-tooltip.hover title="Valider avec Enter"
                      class="p-inputtext-sm"
                    />
                  </span>
                  <button 
                    @click="downloadGrid()"
                    type="button"
                    class="ml-2 d-inline btn btn-success btn-block btn-auto"
                    v-b-tooltip.hover title="Télécharger au format CSV"
                    >
                    <font-awesome-icon icon="download"></font-awesome-icon>  
                    Télécharger
                  </button>

                  <button
                    v-if="
                      userConnected.roles.includes('ROLE_USER') ||
                      userConnected.roles.includes('ROLE_SOUSTRAITANT') ||
                      userConnected.roles.includes('ROLE_ADMIN')
                    "
                    @click="goToNewDossier()"
                    type="button"
                    class="ml-2 d-inline btn btn-primary btn-block btn-auto"
                    style="margin-top: 0 !important;"
                  >
                    <font-awesome-icon icon="plus"></font-awesome-icon>
                    Nouvelle demande
                  </button>
                </div>
                <!-- FIN Recherche, Télécharger & Nouvelle Demande -->
                
                <!-- Colonnes à afficher -->
                <div>
                  <h6>Colonnes à afficher</h6>
                  <Multiselect :value="selectedColumns" :options="columns" optionLabel="header" @input="onToggle" placeholder="Sélectionner" style="width: 20em;"/>
                </div>
                <!-- FIN Colonnes à afficher -->
              </div>
            </template>

            <template #empty>
              Aucune donnée trouvée
            </template>

            <template #loading>
              Chargement, veuillez patienter
            </template>

            <Column field="id" header="N°" sortable :showFilterMatchModes="false" v-if="isSelected('id')" :styles="{ width: '70px' }">
              <template #body="{data}">
                {{ data.id }}
              </template>
            </Column>

            <Column field="cerfa1402301" header="Type" sortable :showFilterMatchModes="false" v-if="isSelected('type')" :styles="{ width: '80px' }">
              <template #body="{data}">
                <div style="text-align: center !important;">
                  <span
                    v-if="
                      data.cerfa1402301 != null &&
                      data.cerfa1402401 == null
                    "
                  >
                    <font-awesome-icon
                      :class="
                        data.cerfa1402301_fav != null
                          ? data.cerfa1402301_fav
                            ? 'green'
                            : 'red'
                          : ''
                      "
                      :id="'tooltip-type-' + data.id"
                      icon="road"
                    ></font-awesome-icon>
                    <b-tooltip
                      :target="'tooltip-type-' + data.id"
                      triggers="hover"
                    >
                      Permission de voirie - cerfa n°14023*01
                    </b-tooltip>
                  </span>
                  <span
                    v-if="
                      data.cerfa1402401 != null &&
                      data.cerfa1402301 == null
                    "
                  >
                    <font-awesome-icon
                      :class="
                        data.cerfa1402401_fav != null
                          ? data.cerfa1402401_fav
                            ? 'green'
                            : 'red'
                          : ''
                      "
                      :id="'tooltip-type-' + data.id"
                      icon="car"
                    ></font-awesome-icon>
                    <b-tooltip
                      :target="'tooltip-type-' + data.id"
                      triggers="hover"
                    >
                      Arrêté de circulation - cerfa n°14024*01
                    </b-tooltip>
                  </span>
                  <span
                    v-if="
                      data.cerfa1402401 == null &&
                      data.cerfa1402301 == null
                    "
                  >
                    <font-awesome-icon
                      :id="'tooltip-type-' + data.id"
                      icon="question-circle"
                    ></font-awesome-icon>
                    <b-tooltip
                      :target="'tooltip-type-' + data.id"
                      triggers="hover"
                    >
                      Pas de type
                    </b-tooltip>
                  </span>
                  <span
                    v-if="
                      data.cerfa1402401 != null &&
                      data.cerfa1402301 != null
                    "
                  >
                    <font-awesome-icon
                      :class="
                        data.cerfa1402301_fav != null
                          ? data.cerfa1402301_fav
                            ? 'green'
                            : 'red'
                          : ''
                      "
                      :id="'tooltip-type-' + data.id"
                      icon="road"
                    ></font-awesome-icon>
                    <font-awesome-icon
                      :class="
                        data.cerfa1402401_fav != null
                          ? data.cerfa1402401_fav
                            ? 'green'
                            : 'red'
                          : ''
                      "
                      :id="'tooltip-type-' + data.id"
                      icon="car"
                    ></font-awesome-icon>
                    <b-tooltip
                      :target="'tooltip-type-' + data.id"
                      triggers="hover"
                    >
                      Permission de voirie et Arrêté de circulation
                    </b-tooltip>
                  </span>
                </div>
                  
              </template>
              <template #filter="{filterModel}">
                <Dropdown v-model="filterModel.value" :options="types" optionLabel="name" optionValue="id" placeholder="Tous" class="p-column-filter">
                  
                </Dropdown>
              </template>
            </Column>

            <Column field="state_name" header="Statut" sortable :showFilterMatchModes="false" v-if="isSelected('statut')" :styles="{ width: '90px' }">
              <template #body="{data}">
                <div style="text-align: center;">
                  <span
                  :id="'tooltip-state-' + data.id"
                  :class="'status-table statut-' + data.state_id"
                ></span>
                <b-tooltip
                  :target="'tooltip-state-' + data.id"
                  triggers="hover"
                >
                  {{ data.state_name }}
                </b-tooltip>
                <div class="d-none">
                  {{ data.state_name }}
                </div>
                </div>
              </template>
              <template #filter="{filterModel}">
                <Dropdown v-model="filterModel.value" :options="states" optionLabel="name" optionValue="name" placeholder="Tous" class="p-column-filter">
                  
                </Dropdown>
              </template>
            </Column>

            <Column field="ticketOfficePerimeter" header="Guichet" sortable :showFilterMatchModes="false" v-if="isSelected('guichet')" :styles="{ width: '105px' }">
              <template #body="{data}">
                <span :id="'top-' + data.id">
                  {{ data.ticketOfficePerimeter }}
                </span>
                <b-tooltip
                  :target="'top-' + data.id"
                  triggers="hover"
                >
                  {{ data.ticketOfficePerimeter }}
                </b-tooltip>
              </template>
              <template #filter="{filterModel}">
                <Dropdown v-model="filterModel.value" :options="guichets" optionLabel="libelle" optionValue="libelle" placeholder="Tous" class="p-column-filter">

                </Dropdown>
              </template>
            </Column>

            <Column field="managerPerimeter" header="Gestionnaire" sortable :showFilterMatchModes="false" v-if="isSelected('gestionnaire')" :styles="{ width: '132px' }">
              <template #body="{data}">
                <span :id="'mp-' + data.id">
                  {{ data.managerPerimeter }}
                </span>
                <b-tooltip
                  :target="'mp-' + data.id"
                  triggers="hover"
                >
                  {{ data.managerPerimeter }}
                </b-tooltip>
              </template>
              <template #filter="{filterModel}">
                <Dropdown v-model="filterModel.value" :options="gestionnaires" optionLabel="libelle" optionValue="libelle" placeholder="Tous" class="p-column-filter">

                </Dropdown>
              </template>
            </Column>

            <Column field="operatorPerimeter" header="Opérateur" sortable :showFilterMatchModes="false" v-if="isSelected('operateur')" :styles="{ width: '120px' }">
              <template #body="{data}">
                <span :id="'op-' + data.id">
                  {{ data.operatorPerimeter }}
                </span>
                <b-tooltip
                  :target="'op-' + data.id"
                  triggers="hover"
                >
                {{ data.operatorPerimeter }}
                </b-tooltip>
              </template>
              <template #filter="{filterModel}">
                <Dropdown v-model="filterModel.value" :options="operateurs" optionLabel="libelle" optionValue="libelle" placeholder="Tous" class="p-column-filter">

                </Dropdown>
              </template>
            </Column>

            <Column field="sousTraitantPerimeter" header="Sous-Traitant" sortable :showFilterMatchModes="false" v-if="isSelected('sousTraitant')" :styles="{ width: '135px' }">
              <template #body="{data}">
                <span :id="'st-' + data.id">
                  {{ data.sousTraitantPerimeter }}
                </span>
                <b-tooltip
                  :target="'st-' + data.id"
                  triggers="hover"
                >
                  {{ data.sousTraitantPerimeter }}
                </b-tooltip>
              </template>
              <template #filter="{filterModel}">
                <Dropdown v-model="filterModel.value" :options="sousTraitants" optionLabel="libelle" optionValue="libelle" placeholder="Tous" class="p-column-filter">

                </Dropdown>
              </template>
            </Column>

            <Column field="addressNum" header="Adresse" sortable :showFilterMatchModes="false" v-if="isSelected('adresse')" :styles="{ width: '115px' }">
              <template #body="{data}">
                <span :id="'adresse-' + data.id">
                  {{ data.addressNum }} {{ data.addressExt }} <br>
                  {{ data.addressType }} {{ data.addressName }}
                </span>
                <b-tooltip
                  :target="'adresse-' + data.id"
                  triggers="hover"
                >
                  {{ data.addressNum }} {{ data.addressExt }} {{ data.addressType }} {{ data.addressName }}
                </b-tooltip>
              </template>
              <template #filter="{filterModel}">
                <InputText type="text" v-model="filterModel.value" class="p-column-filter" placeholder="Recherche par adresse"/>
              </template>
            </Column>

            <Column field="addressPostalCode" header="CP" sortable :showFilterMatchModes="false" v-if="isSelected('codePostal')" :styles="{ width: '70px' }">
              <template #body="{data}">
                {{ data.addressPostalCode }}
              </template>
              <template #filter="{filterModel}">
                <InputText type="text" v-model="filterModel.value" class="p-column-filter" placeholder="Recherche par code postal"/>
              </template>
            </Column>

            <Column field="addressCity" header="Localité" sortable :showFilterMatchModes="false" v-if="isSelected('localite')" :styles="{ width: '105px' }">
              <template #body="{data}">
                <span :id="'loc-' + data.id">
                  {{ data.addressCity }}
                </span>
                <b-tooltip
                  :target="'loc-' + data.id"
                  triggers="hover"
                >
                  {{ data.addressCity }}
                </b-tooltip>
              </template>
              <template #filter="{filterModel}">
                <InputText type="text" v-model="filterModel.value" class="p-column-filter" placeholder="Recherche par localité"/>
              </template>
            </Column>

            <Column field="zoneAMII" header="ZA" dataType="boolean" sortable :showFilterMatchModes="false" v-if="isSelected('za')" :styles="{ width: '70px' }">
              <template #body="{data}">
                <div style="text-align: center;">
                  <span v-if="data.zoneAMII != null && data.zoneAMII != ''">
                    <font-awesome-icon icon="check" :id="'za-' + data.id"/>
                    <b-tooltip
                      :target="'za-' + data.id"
                      triggers="hover"
                    >
                      Zone AMII: {{ data.zoneAMII }}
                    </b-tooltip>
                    <span class="d-none">
                      {{ data.zoneAMII != null && data.zoneAMII != '' }}
                    </span>
                  </span>
                  <span v-else>
                    <font-awesome-icon icon="times" :id="'za-' + data.id"/>
                    <b-tooltip
                      :target="'za-' + data.id"
                      triggers="hover"
                    >
                      Zone AMII non définie
                    </b-tooltip>
                    <span class="d-none">
                      {{ data.zoneAMII != null && data.zoneAMII != '' }}
                    </span>
                  </span>
                </div>
              </template>
              <template #filter="{filterModel}">
                <TriStateCheckbox v-model="filterModel.value" />
              </template>
            </Column>

            <Column field="depositDate" header="Dépôt" dataType="date" sortable :showFilterMatchModes="false" v-if="isSelected('depot')" :styles="{ width: '95px' }">
              <template #body="{data}">
                {{ formatDate(data.depositDate) }}
              </template>
              <template #filter="{filterModel}">
                <Calendar v-model="filterModel.value" dateFormat="dd/mm/yyyy" placeholder="jj/mm/aaaa"  @date-select="parseDate($event,filterModel)"/>
              </template>
            </Column>

            <Column field="dateStart" header="Début" dataType="date" sortable :showFilterMatchModes="false" v-if="isSelected('debut')" :styles="{ width: '95px' }">
              <template #body="{data}">
                {{ formatDate(data.dateStart) }}
              </template>
              <template #filter="{filterModel}">
                <Calendar v-model="filterModel.value" dateFormat="dd/mm/yyyy" placeholder="jj/mm/aaaa" @date-select="parseDate($event,filterModel)"/>
              </template>
            </Column>

            <Column header="Actions" :styles="{ width: '120px' }"> 
              <template #body="{data}">
                <b-button
                      @click="goToDossier(data)"
                      v-b-tooltip.hover
                      title="Ouvrir la demande"
                      variant="primary"
                      class="mr-2"
                      size="sm"
                    >
                      <font-awesome-icon icon="eye"></font-awesome-icon>
                    </b-button>
                    <b-button
                      @click="locate(data)"
                      v-b-tooltip.hover
                      title="Localiser la demande"
                      variant="warning"
                      class="mr-2"
                      size="sm"
                    >
                      <font-awesome-icon
                        @click="locate(data)"
                        icon="map-marker-alt"
                      ></font-awesome-icon>
                    </b-button>
                    <b-button
                      v-if="
                        userConnected.roles.includes('ROLE_USER') ||
                        userConnected.roles.includes('ROLE_SOUSTRAITANT') ||
                        userConnected.roles.includes('ROLE_ADMIN')
                      "
                      v-b-tooltip.hover
                      title="Renouveler la demande"
                      @click="showPopupRenew(dossier)"
                      variant="info"
                      class="mr-2"
                      size="sm"
                    >
                      <font-awesome-icon icon="copy"></font-awesome-icon>
                    </b-button>
              </template>
            </Column>

          </DataTable>
          <!-- FIN Primevue -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import router from "../router/index";
import maps from "../components/Maps.vue";
import headergrid from "../components/HeaderGrid.vue";
import Vuex from "vuex";
import {
  createProj,
  addProj,
  findPointOnSurface,
  createStyle,
  createMultiPointGeom,
  loadingBBox,
} from "vuelayers/lib/ol-ext";
import Style from "ol/style/Style";
import Fill from "ol/style/Fill";
import Stroke from "ol/style/Stroke";
import Icon from "ol/style/Icon";
import Text from "ol/style/Text";
import Point from "ol/geom/Point";
import { addDays, format } from "date-fns";
import historyMails from "../components/historyMails.vue";
// Primevue
import {FilterMatchMode} from 'primevue/api/';

export default {
  watch: {
    mapStatus: {
      handler: function (val) {
        if (val == true) {
          this.$nextTick(() => {
            if (window.Event) {
              window.Event.$emit("refreshMap");
            }
          });
        }
      },
    }
  },
  async mounted() {
    await this.getStates();

    // this.guichets = await this.getPerimeters({type: 'epci'}),
    this.guichets = [
      {
        "id" : 953,
        "libelle" : "CC du Golfe de Saint-Tropez"
      },
      {
        "id" : 962,
        "libelle" : "Estérel Côte d’Azur Agglomération" 
      },
      {
        "id" : 963,
        "libelle" : "CC du Pays de Fayence"
      },
      {
        "id" : 964,
        "libelle" : "CC Lacs et Gorges du Verdon"
      },
      {
        "id" : 971,
        "libelle" : "CC Provence Verdon"
      },
      {
        "id" : 972,
        "libelle" : "CA de la Provence Verte"
      },
      {
        "id" : 973,
        "libelle" : "CA Dracénie Provence Verdon"
      },
      {
        "id" : 980,
        "libelle" : "CA Sud Sainte-Baume"
      },
      {
        "id" : 982,
        "libelle" : "CC Coeur du Var"
      },
      {
        "id" : 986,
        "libelle" : "Métropole Toulon-Provence-Méditerranée"
      },
      {
        "id" : 990,
        "libelle" : "CC de la Vallée du Gapeau"
      },
      {
        "id" : 992,
        "libelle" : "CC Méditerranée Porte des Maures"
      }
    ];
    this.gestionnaires = await this.getPerimeters({type: 'department'}),
    this.operateurs = await this.getPerimeters({type: 'operator'}),
    this.sousTraitants = await this.getPerimeters({type: 'soustraitant'}),

    this.runSearch({
      first : 0,
      rows : JSON.parse(localStorage.getItem("dt-state-demo-session")).rows || 10,
      sortField : 'id',
      sortOrder : -1,
      filters : JSON.parse(localStorage.getItem("filter-sud-thd"))
    });

  },
  name: "Listing",
  data: () => ({
    dateStart : null,
    dateStartTvx: null,
    dateEndTvx: null,
    mapStatus: false,
    showMails: false, 
    showMailsId: null,
    // Colonnes à afficher
    selectedColumns: null,
    columns: null,
    // FIN Colonnes à afficher
    types: [
          { id: "cerfa1402301", name: "Permission de voirie (Cerfa 1402301)" },
          { id: "cerfa1402401", name: "Arrêté de circulation (Cerfa 1402401)" },
        ],
    // Primevue filters:
    filters : {
      'global': { value: null, matchMode: FilterMatchMode.CONTAINS},
      'cerfa1402301': {value: null, matchMode: FilterMatchMode.EQUALS},
      'state_name': {value: null, matchMode: FilterMatchMode.EQUALS},
      'ticketOfficePerimeter': {value: null, matchMode: FilterMatchMode.EQUALS},
      'managerPerimeter': {value: null, matchMode: FilterMatchMode.EQUALS},
      'operatorPerimeter': {value: null, matchMode: FilterMatchMode.EQUALS},
      'sousTraitantPerimeter': {value: null, matchMode: FilterMatchMode.EQUALS},
      'addressNum': {value: null, matchMode: FilterMatchMode.CONTAINS},
      'addressPostalCode': {value: null, matchMode: FilterMatchMode.CONTAINS},
      'addressCity': {value: null, matchMode: FilterMatchMode.CONTAINS},
      'zoneAMII': {value: null/* , matchMode: FilterMatchMode.IS */},
      'depositDate': {value: null, matchMode: FilterMatchMode.EQUALS},
      'dateStart': {value: null, matchMode: FilterMatchMode.EQUALS}, 
    },
    guichets: [],
    gestionnaires: [],
    operateurs: [],
    sousTraitants: [],
    // FIN Primevue filters
    searchText: "",
    searchSort: "depositDate",
    searchDir: "DESC",
    dateFormat: "YYYY-MM-DD",
    showRenew: false,
    copyRequest: {
      id: null,
      dateStart: null,
      numberDays: null,
      dateEnd: null,
      cerfa14024: false,
    },
    copyCerfa14024: {
      dateRegulation: null,
      durationRegulation: null,
    },
  }),
  created() {
    this.columns = [
      {field: 'id', header: 'N°'},
      {field: 'type', header: 'Type'},
      {field: 'statut', header: 'Statut'},
      {field: 'guichet', header: 'Guichet'},
      {field: 'gestionnaire', header: 'Gestionnaire'},
      {field: 'operateur', header: 'Opérateur'},
      {field: 'sousTraitant', header: 'Sous-Traitant'},
      {field: 'adresse', header: 'Adresse'},
      {field: 'codePostal', header: 'CP'},
      {field: 'localite', header: 'Localité'},
      {field: 'za', header: 'Zone AMII (ZA)'},
      {field: 'depot', header: 'Dépôt'},
      {field: 'debut', header: 'Début'}
    ],

    this.selectedColumns = this.columns;
  },
  components: {
    "history-mail": historyMails,
    maps: maps,
    "header-grid": headergrid,
  },
  methods: {
    async duplicate(request) {
      let id = await this.sendDuplicate(request);
      let encrypted = this.$aes.encrypt(id.toString());
      router.push({
        name: "Dossier",
        params: { id: encrypted },
      });
    },
    async renew() {
      let params = {
        cerfa: this.copyCerfa14024,
        request: this.copyRequest,
      };
      let id = await this.sendRenew(params);
      let encrypted = this.$aes.encrypt(id.toString());
      this.showRenew = false;
      router.push({
        name: "Dossier",
        params: { id: encrypted },
      });
    },
    showPopupRenew(dossier) {
      this.copyRequest.cerfa14024 = dossier.cerfa1402401 != null;
      this.copyRequest.id = dossier.id;
      this.showRenew = true;
    },


    goToNewDossier() {
      router.push({ name: "ajoutdossier" });
    },

  
    calcNumberDays(value) {
      if (
        this.copyRequest.dateStart != null &&
        this.copyRequest.dateEnd != null
      ) {
        let date1 = new Date(this.copyRequest.dateStart);
        let date2 = new Date(this.copyRequest.dateEnd);
        let Difference_In_Days =
          (date2.getTime() - date1.getTime()) / (1000 * 3600 * 24);
        this.copyRequest.numberDays = Difference_In_Days + 1;
      }
    },
    formatDate(date) {
      if (!date) {
        return '-';
      }

      let dateElements = date.split('-');

      let y = dateElements[0];
      let m = dateElements[1];
      let d = dateElements[2];

      return d + '/' + m + '/' + y;
    },
    runSearch(event) {
      let page =
        this.paginationSelected && this.paginationSelected.current
          ? this.paginationSelected.current
          : 1;

      this.getDossiers({
        offset: event.first,
        numItemsPerPage: event.rows,
        searchText: this.searchText,
        searchSort: event.sortField,
        searchDir: event.sortOrder == -1 ? 'DESC' : 'ASC',
        searchFilter:  this.filters,
      });
    },
    onToggle(val) {
      this.selectedColumns = this.columns.filter(col => val.includes(col));
    },
    isSelected(field) {
      let fields = this.selectedColumns.map(c => c.field);
      return fields.includes(field);
    },
    parseDate(value, toChange){
      let year = value.getFullYear();
      let month = value.getMonth() + 1;
      let date = value.getDate();
      
      toChange.value = year + '-' + (month < 10 ? '0' + month : month) + '-' + (date < 10 ? '0' + date : date);
    },
    downloadGrid() {
      let page = "?export=true";

      let searchText = "&searchText=" + this.searchText;
      let searchFilter = "&searchFilter=" + JSON.stringify(this.filters);

      let searchSort = "&searchSort=" + this.searchSort;
      let searchDir = "&searchDir=" + this.searchDir;

      Vue.axios.get(window.urlapi + "request" + page + searchText + searchSort + searchDir + searchFilter).then(
          response => {
              window.open(response.data.data);
          },
      );
    },
    goToDossier(dossier) {
      router.push({ name: "Dossier", params: { id: dossier.id } });
    },
    locate(dossier) {
      if (this.mapStatus == false) {
        this.mapStatus = true;
      }
      window.Event.$emit("locatePoint", dossier);
    },
    ...Vuex.mapActions("Map", ["showBaseLayer"]),
    ...Vuex.mapActions("Dossiers", [
      "getDossiers",
      "sendDuplicate",
      "sendRenew",
    ]),
    ...Vuex.mapActions("State", ["getStates"]),
    ...Vuex.mapActions("Perimeter", ["getPerimeters"]),
  },
  computed: {
    paginationSelected: {
      get() {
        return this.pagination;
      },
      set(value) {
        this.setPagination(value);
      },
    },
    vectorLayers: function () {
      let me = this;
      let tab = [];
      if (typeof this.features !== "undefined") {
        tab.push({
          vectorZIndex: 100,
          ref: "DossierPointLayer",
          visible: true,
          select: true,
          features: this.features,
          factory: function () {
            return (feature) => {
              if (feature.getProperties().marker) {
                return [
                  new Style({
                    zIndex: 150,
                    image: new Icon({
                      src: require("../img/marker-map/" +
                        feature.getProperties().marker),
                      scale: 0.5,
                    }),
                  }),
                ];
              } else {
                return [];
              }
            };
          },
          click: function (id) {
            router.push({ name: "Dossier", params: { id: id } });
          },
        });
      }

      return tab;
    },
    ...Vuex.mapGetters("Dossiers", ["dossiers", "pagination", "features"]),
    ...Vuex.mapGetters("Authentification", ["userConnected"]),
    ...Vuex.mapGetters("State", ["states"]),
    ...Vuex.mapGetters("Perimeter", ["perimeters"]),
  },
};
</script>

<style scoped></style>

<style>
  .p-column-filter-menu-button.p-column-filter-menu-button-active, .p-column-filter-menu-button.p-column-filter-menu-button-active:hover {
    background: #2196F3 !important;
    color: #ffffff !important;
  }
</style>
